import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mock-exams-panel",
  "aria-labelledby": "mock-exams-heading"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "mock-exams-panel__topbar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileMenu = _resolveComponent("ProfileMenu")!
  const _component_MockExamPage = _resolveComponent("MockExamPage")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"mock-exams-panel__decor\" aria-hidden=\"true\" data-v-de3e9490><svg class=\"leaf leaf--1\" viewBox=\"0 0 48 64\" fill=\"none\" data-v-de3e9490><path d=\"M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z\" fill=\"#A5B94F\" opacity=\"0.55\" data-v-de3e9490></path><path d=\"M24 8v46\" stroke=\"#8FA03E\" stroke-width=\"1.5\" stroke-linecap=\"round\" opacity=\"0.5\" data-v-de3e9490></path></svg><svg class=\"leaf leaf--2\" viewBox=\"0 0 48 64\" fill=\"none\" data-v-de3e9490><path d=\"M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z\" fill=\"#A5B94F\" opacity=\"0.45\" data-v-de3e9490></path><path d=\"M24 8v46\" stroke=\"#8FA03E\" stroke-width=\"1.5\" stroke-linecap=\"round\" opacity=\"0.4\" data-v-de3e9490></path></svg><svg class=\"leaf leaf--3\" viewBox=\"0 0 48 64\" fill=\"none\" data-v-de3e9490><path d=\"M24 2C14 14 6 28 8 44c2 12 10 18 16 18s14-6 16-18C42 28 34 14 24 2Z\" fill=\"#A5B94F\" opacity=\"0.5\" data-v-de3e9490></path><path d=\"M24 8v46\" stroke=\"#8FA03E\" stroke-width=\"1.5\" stroke-linecap=\"round\" opacity=\"0.45\" data-v-de3e9490></path></svg></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "mock-exams-panel__back",
          "aria-label": "بازگشت به داشبورد",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.goBack && $options.goBack(...args)))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            width: "20",
            height: "20",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "aria-hidden": "true"
          }, [
            _createElementVNode("path", {
              d: "M5 12H19",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }),
            _createElementVNode("path", {
              d: "M13 6l6 6-6 6",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1),
          _createElementVNode("span", null, "بازگشت", -1)
        ]))]),
        _createVNode(_component_ProfileMenu)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("header", { class: "mock-exams-panel__header" }, [
        _createElementVNode("p", { class: "mock-exams-panel__eyebrow" }, "آزمون شبیه‌ساز"),
        _createElementVNode("h1", {
          id: "mock-exams-heading",
          class: "mock-exams-panel__title"
        }, "کتاب و آزمون مورد نظرت رو انتخاب کن"),
        _createElementVNode("p", { class: "mock-exams-panel__subtitle" }, " از میان کتاب‌های کمبریج، آزمون دلخواهت رو شروع کن و پیشرفتت رو دنبال کن. ")
      ], -1)),
      _createVNode(_component_MockExamPage)
    ])
  ]))
}